<template>
  <div class='rolePage'>
    <v-search :formContent='formContent' :SearchForm='SearchForm' :inline='true' :optareBtn='optareBtn'
              @resetFn='resetFn'
              class='search' @confirmFn='getListFn' @searchFn='getListFn' @addFn='addFn' @DelFn='DelFn'>
    </v-search>
    <div class='componentPage'>
      <roleTable :tableData='tableData' :loading='loading' @detailFn='detailFn' @delFn='delFn'
                 @choozeTableFn='choozeTableFn' />
      <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                  :limit.sync='SearchForm.iDisplayLength' @pagination='getListFn'></Pagination>
    </div>
    <AddDialog :isShow.sync='isShow' :title='title' ref='vForm' :statusArray='statusArray'
               :roleTypeArray='roleTypeArray'
               :customerAddArray='customerAddArray' />
    <!-- 详情 -->
    <DetailDialog :title='title' :statusArray='statusArray' ref='detail' :roleTypeArray='roleTypeArray'
                  :isShowDetail.sync='isShowDetail' :detailObj='detailObj' :detailTree='detailTree'
                  :detailTreeLoad.sync='detailTreeLoad' :customerAddArray='customerAddArray' />
  </div>
</template>

<script>
import mixinForm from '@/utils/formMixins.js'
import publicMix from '@/utils/public.js'
import getRangeMin from '@/utils/getRange.js'
import { roleCustomer, roleDetail, roleList, roleRemove, roleResource } from '@/api/modules/role.js'

import roleTable from './components/RoleTable.vue'
import AddDialog from './components/role/AddDialog.vue'
import DetailDialog from './components/role/Detail.vue'
import { accountType, roleType } from '@/utils/convert'

export default {
  mixins: [mixinForm, publicMix, getRangeMin],
  components: {
    roleTable,
    AddDialog,
    DetailDialog
  },
  data () {
    return {
      SearchForm: {
        name: null,
        status: null,
        customerId: null,
        type: null
      },
      formContent: [
        {
          id: 2,
          text: 'public.table_scope',
          type: 'select',
          paramsName: 'customerId',
          selectParam: [],
          isChooze: false
        },
        {
          id: 1,
          text: 'user.role',
          type: 'input',
          paramsName: 'name',
          isChooze: false
        }
      ],
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.btn_new',
          method: 'addFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['delRange'],
          text: 'public.btn_delete',
          method: 'DelFn'
        }
      ],
      // 状态
      statusArray: [],
      roleTypeArray: [],
      customerArray: [],
      statusIconArray: roleType,
      roleIconArray: accountType,
      // 详情
      isShowDetail: false,
      detailObj: {},
      detailTree: [],
      detailTreeLoad: false,
      // 新增
      customerAddArray: [],
      // 表格操作
      choozeTable: []
    }
  },
  created () {
    this.getInitData({
      code: 'role_status',
      type: 0
    }, 2)
    this.getRoleTypeFn()
    this.getCustomer()
    if (this.$store.state.type !== 3 && this.$store.state.type !== 2) {
      this.formContent.shift()
    }
  },
  methods: {
    getInitData (obj, num) {
      this.shareParamFn(obj).then(({ result }) => {
        this.statusArray = this.changeIn18Data(result, this.statusIconArray)

        this.formContent.forEach(item => {
          if (item.paramsName === 'status') {
            item.selectParam = this.statusArray
          }
        })
      })
    },
    getRoleTypeFn () {
      this.getRoleType().then(({ result }) => {
        this.roleTypeArray = this.changeIn18Data(result, this.roleIconArray)
      })
    },
    changeIn18Data (result = [], iconArray) {
      const array = [{
        value: '',
        label: 'public.please',
        icon: 'el-icon-thumb'
      }]
      return array.concat(result.map((item, index) => {
        return {
          value: parseInt(item.code),
          label: 'public.' + item.content,
          icon: iconArray[item.code].icon
        }
      }))
    },
    getCustomer () {
      this.getRange('customer', 1).then(({ result }) => {
        if (result.length) {
          result.splice(0, 1)
        }
        this.customerArray = this.formContent[0].selectParam = result.map(item => {
          return {
            value: item.id,
            label: item.id === '-1' || item.id === '-2' ? 'public.' + item.name : item.name
          }
        })
        this.customerArray.unshift({
          value: null,
          label: 'public.please'
        })
      })
    },
    async addFn () {
      this.isShow = true
      this.title = this.$t('user.add_role')
      // 合并 type=0（普通企业）和 type=2（V-mark 平台）的 customer 列表
      const [res0, res2] = await Promise.all([
        roleCustomer({ type: 0 }),
        roleCustomer({ type: 2 })
      ])
      const idSet = new Set()
      this.customerAddArray = [...(res0.result || []), ...(res2.result || [])].filter(item => {
        if (idSet.has(item.id)) return false
        idSet.add(item.id)
        return true
      })
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
      })
    },
    // 获取客户
    getCustomerFn () {
      roleCustomer({ type: this.roleTypeArray[1].value }).then(({ result }) => {
        this.customerAddArray = result || []
      })
    },
    DelFn () {
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        status: null,
        customerId: null,
        type: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      this.getListFn()
    },
    getListFn () {
      this.loading = true
      roleList(this.SearchForm).then(({
        result,
        pageInfo
      }) => {
        this.tableData = result
        this.total = pageInfo.total
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },

    // 详情
    async detailFn (row) {
      this.isShowDetail = true
      this.title = this.$t('user.role_info')
      this.detailTreeLoad = true
      this.$nextTick(() => {
        this.$refs.detail.ismode = true
      })

      const { result } = await roleDetail({ id: row.id })
      this.detailObj = result
      const query = {
        id: result.id,
        type: result.type,
        isEdit: 0
      }

      roleResource(query).then(({ result }) => {
        this.detailTree = result.item || []
      }).finally(() => {
        this.detailTreeLoad = false
      })
      roleCustomer({ type: result.type }).then(({ result }) => {
        this.customerAddArray = result || []
      })
    },
    /** 勾选表格 */
    choozeTableFn (array) {
      this.choozeTable = array
    },
    // 删除
    delFn (row) {
      if (row.isDefault === 1 || row.is_default === 1) return this.$message.error(this.$t('user.tip_del_default_role'))
      this.TODOTIPDEL(row.id)
    },
    DelFn () {
      const flag = this.cehckDefaultRole()
      if (!flag) return this.$message.error(this.$t('user.tip_del_default_role_multi'))
      if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const ids = this.choozeTable.map(item => item.id).join(',')
      this.TODOTIPDEL(ids)
    },
    cehckDefaultRole () {
      let flag = true
      for (const item of this.choozeTable) {
        if (item.isDefault === 1 || item.is_default === 1) {
          flag = false
          break
        }
      }
      return flag
    },
    /**
     *
     * @param {*param 选中数据id} param string
     */
    TODOTIPDEL (param) {
      this.$confirm(
        this.$t('user.tip_del_role'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      ).then(() => {
        roleRemove({ id: param }).then(({ result }) => {
          if (result === 200) {
            this.getListFn()
            this.$message.success(
              this.$t(this.$t('public.tip_del_succ')).toString()
            )
          } else {
            this.$message.error(this.$t('public.tip_del_fail'))
          }
        })
      }).catch(() => {
      })
    }

  }
}
</script>

<style lang='scss' scoped>
.rolePage {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;

  .search {
    position: relative;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
